"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24PhoneCallLine = function Svg24PhoneCallLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13 6.118C2.91 4.342 4.383 3 6 3h1.416a3 3 0 0 1 2.92 2.312l.434 1.84a3 3 0 0 1-1.579 3.37L7.058 11.59a15.08 15.08 0 0 0 5.353 5.353l1.067-2.133a3 3 0 0 1 3.37-1.579l1.84.434A3 3 0 0 1 21 16.584V18c0 1.618-1.342 3.09-3.118 2.87a16.891 16.891 0 0 1-5.487-1.662 17.068 17.068 0 0 1-7.603-7.603 16.89 16.89 0 0 1-1.661-5.487zm11.07 11.72c1.234.518 2.552.875 3.928 1.046.416.052.872-.293.872-.884v-1.416a1 1 0 0 0-.77-.974l-1.84-.433a1 1 0 0 0-1.123.526l-1.068 2.134zM6.162 9.8l2.134-1.067a1 1 0 0 0 .526-1.124L8.39 5.77A1 1 0 0 0 7.416 5H6c-.591 0-.936.456-.884.872A14.892 14.892 0 0 0 6.163 9.8z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24PhoneCallLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24PhoneCallLine;
exports.default = _default;